import Response from "./Response";

export default {
    init() {
        $(document).on("click", "[data-ajax-action]", function (event) {
            event.preventDefault();
            event.stopPropagation();
            const element = $(this);
            const url = element.attr("href");
            if (!url) return;

            const proceed = () => {
                $.post(url)
                    .done((response) => Response.handle(response))
                    .fail((xhr) => {
                        console.log(xhr);
                        Response.error(xhr);
                    });
            };
            const message = element.data("ajax-confirm");
            if (!message) return proceed();

            Swal.fire({
                title: "Wymagane potwierdzenie",
                text: message,
                icon: "warning",
                showCancelButton: true,
                cancelButtonColor: "#3085d6",
                confirmButtonColor: "#d33",
                confirmButtonText: "Tak",
                cancelButtonText: "Nie",
            }).then((result) => {
                if (result.isConfirmed) proceed();
            });
        });
    },
};
